import React, { Component } from "react";
import EpComponent from '../components/EpComponent';
import Landing from './../../landing/containers/LandingContainer';
import { api_base } from '../../constants/services/api'
import { sendService } from "../../Services/service";
import ViewQR from "../components/ViewQR";


import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './../../Actions/Dashboard';
import * as ModalActs from './../../Actions/Modal';

import "../style.css";


class EpContainer extends Component {
  state = {
    cant: '',
    getqrs: false,
    qrlist: [],
    control: { count: 0, page: '0', pages: 0, pageSize: 20 },
    searchError: false,
    search: '',
    loading: false,
    filterIep: '0',
    startDate: '',
    endDate: '',
    ieps: [],
    barrioFilter: [],
    barrio: '0',
  }

  onChangeRoute = (route) => {
    this.props.actions.activePage(route);
    this.props.history.push(route);
  }

  handlerTextPunto = e => {
    if (e.target.value === '') this.setState({ getqrs: false })
    else this.setState({ cant: parseInt(e.target.value), getqrs: true })
  }

  handlerSearch = e => {
    this.setState({
      search: e.target.value,
      searchError: false
    })
  }

  handlerKeyUp = e => {
    if (e.keyCode === 13)
      this.getSearch()
  }

  getSearch = () => {
    this.getPageData()
  }

  getQrs = () => {
    if (this.state.getqrs)
      window.open(`${api_base}/api/v1/ep/getqr?cant=${this.state.cant}`, '_blank')
  }

  getPdf = (id) => {
    window.open(`${api_base}/api/v1/ep/getPdfDocument/${id}`, '_blank')
  }

  getQr = (qr) => {
    window.open(`${api_base}/api/v1/ep/getqr?qr=${qr}`, '_blank')
  }

  componentDidMount() {
    this.getPageData()
  }

  getPageData = (page = 0) => {
    this.setState({ loading: true })
    sendService(`/api/v1/ep/getpageable?page=${page}&search=${this.state.search}`, "GET").then(value => {
      this.setState({ qrlist: value.response.rows, control: value.response.control, loading: false })
    })
  };

  openQr = (id) => {
    sendService(`/api/v1/ep/get/${this.state.qrlist.find(f => f.id === id).qr}`, "GET").then(value => {
      this.props.modalActions.openModal(
        <ViewQR close={this.props.modalActions.closeModal} qrData={value.response} onSave={(s) => this.editQr(s)} />
      )
      console.log(document.getElementById('map-view'))
    })

    this.props.modalActions.openModal(
      <div>cargando...</div>
    )
  }

  editQr = (data) => {
    this.props.modalActions.closeModal()
    this.props.modalActions.openLoader()
    sendService(`/api/v1/ep/edit`, "POST", {
      ...data,
      diasLaborales: data.diasLaborales ? data.diasLaborales.reduce((p, c) => `${p}${c.id}`, '') : ''
    }).then(value => {
      this.props.modalActions.closeLoader()
      if (value.status !== 200) {
        alert('Problemas con la carga de los datos')
      }
    })
  }

  render() {
    return (
      <Landing history={this.props.history} hasFooter={false}>
        <EpComponent
          state={this.state}
          session={this.props.session}
          onChangeRoute={this.onChangeRoute}
          handlerTextPunto={this.handlerTextPunto}
          handlerSearch={this.handlerSearch}
          searchKeyUp={this.handlerKeyUp}
          onGetSearch={this.getSearch}
          onGetQrs={this.getQrs}
          onGetQr={this.getQr}
          onGetPdf={this.getPdf}
          onOpenQr={this.openQr}
          onChangePage={this.getPageData}
        />
      </Landing>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
    modalActions: bindActionCreators(ModalActs, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EpContainer);